import axios from "axios";
import { API_URL } from "../config";

let interceptorAttached = false;

export const setupAxiosGlobal = () => {
  if (interceptorAttached) return;
  interceptorAttached = true;

  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    const requestUrl = config.url || "";
    const skipAuth =
      config.headers?.["X-Skip-Auth"] === "true" ||
      config.headers?.["x-skip-auth"] === "true";
    const isApiRequest =
      requestUrl.startsWith("/api") ||
      (API_URL && requestUrl.startsWith(API_URL));

    if (!skipAuth && token && isApiRequest && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });
};
